/* eslint-disable react-hooks/exhaustive-deps */
import { useApi } from '@backstage/core-plugin-api';
import {
  NotificationApi,
  notificationApiRef,
} from '../../../../../../apis/notificationApi';
import { toolsProvisioningApiRef } from '../../../../../../apis/toolsProvisioningApi';
import { useEffect, useState } from 'react';

export const useSLA = (apmNumber: string) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);
  const toolsprovisioningApi = useApi(toolsProvisioningApiRef);

  const [slaList, setSLAList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchMyAPI = async () => {
    setIsLoading(true);
    if (toolsprovisioningApi) {
      try {
        const response: any = await toolsprovisioningApi.getSLAList(apmNumber);
        if (response?.status === 200 || response || response === null) {
          setIsLoading(false);
          setSLAList(response);
        }
      } catch (error) {
        setIsLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
  };

  const addSLA = async (sla: any, slaId?: string) => {
    setIsLoading(true);
    if (toolsprovisioningApi) {
      try {
        const response = await toolsprovisioningApi.addSLA(sla, slaId);
        if (response?.status === 200) {
          setIsLoading(false);
          setSLAList((prevState: any) => ({ ...prevState, response }));
          notificationApi.sendNotification({
            message: `SLA ${slaId ? 'updated' : 'added'} successfully`, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setIsLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const addEditTransaction = async (
    transaction: any,
    slaId: string,
    type?: string,
  ) => {
    setIsLoading(true);
    if (toolsprovisioningApi) {
      try {
        const response = await toolsprovisioningApi.addEditTransaction(
          transaction,
          slaId,
          type,
        );
        if (response?.status === 200) {
          setIsLoading(false);
          setSLAList((prevState: any) => ({ ...prevState, response }));
          notificationApi.sendNotification({
            message: `Transaction ${
              type === 'edit' ? 'updated' : 'added'
            } successfully`, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setIsLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  useEffect(() => {
    fetchMyAPI();
  }, []);

  const refreshSLAList = () => {
    setIsLoading(true);
    fetchMyAPI();
  };

  return {
    slaList,
    isLoading,
    refreshSLAList,
    addSLA,
    addEditTransaction,
  } as const;
};
